export const environment = {
  production: true,
  api_url: 'https://www.volg.shop/api/v1/',
  heroku_url: 'https://py-volg-prod-e474d0631bf9.herokuapp.com/api/v1/'
};
